import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { mapObjectToArray } from "@exonn/utils";
import { AlertList } from "src/components/AlertV2/AlertList.tsx";
import type { AccountingPostingValidationErrorData } from "src/components/Form/hooks/useResourceForm/useResourceForm.tsx";
import { useErpTranslation } from "src/system/useErpTranslation.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import { FormAction } from "src/components/Form/Form.types.ts";

export const AccountingPostingValidationError = ({
  data,
}: {
  data: AccountingPostingValidationErrorData;
}) => {
  const { posting_errors, position_errors } = data;

  const { t } = useErpTranslation({
    type: "form",
    resource: ResourceEnum.AccountingPosting,
    formType: FormAction.Edit,
  });

  const postingErrors = mapObjectToArray(posting_errors, (value, key) => {
    return {
      title: t(`postingErrors.${key}`, {
        defaultValue: value,
      }),
    };
  });

  const positionErrors = mapObjectToArray(
    position_errors,
    (value, positionNumber) => {
      return {
        title: t(`errorsForPosition`, {
          number: positionNumber,
        }),
        items: mapObjectToArray(value, (errorText, code) => {
          return t(`positionErrors.${code}`, {
            defaultValue: errorText,
          });
        }),
      };
    },
  ).flat();

  const items = [...postingErrors, ...positionErrors];
  return (
    <AlertList
      title={t("notifications.formSaveFailed", {
        ns: TranslationNamespaceEnum.FormComponent,
      })}
      items={items}
    />
  );
};
